import { $api } from '@service/RequestService';
import { Pagination } from '@utils/models/Pagination';
import { stringifyUrl } from 'query-string';
import { useInfiniteQuery } from 'react-query';

import { realtorSearchModels } from 'modules/realtor/search';

import { realtorBookingConstants } from '..';

export const useRealtorBookingLead = (props: { leadId?: number } = {}) =>
  useInfiniteQuery<
    Pagination<{
      number: number | null;
      flat: realtorSearchModels.IFlatRealtor;
      id: number;
      note: any;
      status: string;
      createdDate: string;
    }>
  >({
    queryKey: [realtorBookingConstants.queryKeys.REALTOR_BOOKING_LEAD, props],
    queryFn: async ({ pageParam }) => {
      const res = await $api.get(
        stringifyUrl({ url: '/v1/realtor-booking/lead', query: { size: 10, ...props, page: pageParam } })
      );

      return res.data.data;
    },
    getNextPageParam: (lastPage, page) => {
      if (page.length < lastPage?.totalPages) {
        return page.length + 1;
      }
      return undefined;
    },
    enabled: !!props.leadId
  });
